import { WaterOpacityIcon } from './WaterOpacityIcon';

/**
 * author: Michael Irigoyen
 * id 97D5ABBB-9410-4891-B06C-40121506BAEC
 * name water-opacity
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-opacity.svg
 * tags
 * - Home Automation 
 * - Drawing / Art 
 * - Weather 
 */
export const WaterSaverIcon = WaterOpacityIcon;
export default WaterSaverIcon